import React, { useState, useEffect } from "react";
import api from "../../services/api";
import { isMobile } from "react-device-detect";

import { Avatar, ListItem, ListItemText } from "@mui/material";
import { useHistory } from "react-router-dom";
import CustomizedSnackbars from "../../components/alert/Alert";

let ultimoIndex = 3;
let text = "";
let tipo = "";
export default function Videos({ unidadeId }) {
  const history = useHistory();
  const [alerta, setAlerta] = useState(false);
  const [listaVideos, setListaVideos] = useState([]);

  useEffect(() => {
    carregarVideos();
  }, []);

  const carregarVideos = () => {
    api
      .get("unidades/listarVideos", { unidadeId })
      .then((res) => {
        console.log(res);
        setListaVideos(res);
        ultimoIndex = res.length;
      })
      .catch((e) => {
        console.log(e);

        const status = e.status;

        if (status === 400) {
          text =
            "Não foi possível listar os vídeos. Verifique sua conexão e tente novamente.";
          tipo = "error";
          alertMsg();
        }
      });
  };

  // const opts = {
  //   height: "99%",
  //   // width: "100%",
  //   playerVars: {
  //     // https://developers.google.com/youtube/player_parameters
  //     autoplay: 1,
  //   },
  // };

  const alertMsg = () => {
    setAlerta(true);
    setTimeout(() => setAlerta(false), 3000);
  };

  return (
    <div
      style={{
        borderBottomRightRadius: 15,
        borderBottomLeftRadius: 15,
        borderRight: "2px solid rgb(213, 213, 213)",
        borderBottom: "2px solid rgb(213, 213, 213)",
        borderLeft: "2px solid rgb(213, 213, 213)",
      }}
    >
      {listaVideos.map((video, index) => (
        <>
          <ListItem
            sx={{
              width: "100%",
              borderBottomRightRadius: index + 1 === 3 ? 15 : 0,
              borderBottomLeftRadius: index + 1 === 3 ? 15 : 0,
              borderTopRightRadius: index === 0 ? 15 : 0,
              cursor: "pointer",
            }}
            onClick={() =>
              history.push({
                pathname: "video",
                state: { dadosVideo: video },
              })
            }
          >
            <Avatar
              variant="rounded"
              src={`https://img.youtube.com/vi/${video.referencia}/0.jpg`}
              sx={{ width: isMobile ? 100 : 200, height: isMobile ? 80 : 100 }}
            ></Avatar>
            <ListItemText
              primary={
                <h3
                  style={{
                    fontFamily: "Gilroy-ExtraBold",
                    paddingLeft: 30,
                    color: "#A3A3A3",
                  }}
                >
                  {video.titulo}
                </h3>
              }
            />
          </ListItem>
          {alerta && (
            <CustomizedSnackbars texto={text} tipo={tipo}></CustomizedSnackbars>
          )}
        </>
      ))}
    </div>
  );
}
